
import sharedStyles from 'styles/css/SharedStyles.module.scss';
// import styles from 'styles/css/Main.module.scss';
// import drawerStyles from 'styles/css/Drawer.module.scss';
// import actionStyles from 'styles/css/ActionStyles.module.scss';
// import Logo from 'styles/images/logo/logo512.png';

import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import discountStyles from 'styles/css/DiscountStyles.module.scss';

const FutureProjects = () => {

    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page-btm']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />

                

                <div className={[discountStyles['box-bg-image'], sharedStyles['text-primary']].join(' ')} style={{marginTop: '16px'}}>
                    <p className={formStyles['text-center']}>
                        حضرت امیرالمؤمنین صلوات الله و سلامه علیه در خطبه ۱۱۰ نهج‌البلاغه فرموده اند:
                    </p>
                    <p className={[formStyles['text-center'], ruleStyles['font-weight-800']].join(' ')}>
                        و تعلمو القرآن ، فانه احسن الحدیث
                        <br />
                        و تفقهوا فیه، فانه ربیع القلوب
                    </p>
                    <p className={formStyles['text-center']}>
                        (قرآن مجید را فراگیرید، زیرا که بهترین گفتار است و در آن، اندیشه و تفکر عمیق کنید، زیرا قرآن، بهار دلهاست)
                    </p>
                </div>


                <p className={ruleStyles['text-justify']}>
                    ۱- دار القرآن الکریم، مسجد و کتابخانه حضرت علی ابن ابیطالب صلوات الله و سلامه علیه در شیراز  و شهرضا
                    <br />
                    زمان تقریبی پروژه: 2 تا 3 سال
                    <br />
                    محل تامین اعتبار ساخت پروژه: درآمد دکتر بیست (ان شاءالله )
                    <br />
                    مجری پروژه: در حال بررسی (هنوز طراحی پروژه، نهایی نشده است)
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۲- اقامتگاه همراه بیمار جهت بیمارستانهای دولتی (بیمارستان مرحوم نمازی، شهید فقیهی، شهید بهشتی، شهید چمران و….)
                </p>

                <p className={ruleStyles['text-justify']}>
                    ۳-فود استور جهت خانواده‌های محترم ایتام و بی سرپرست
                </p>

            </div>
                
        </div>

    );
}

export default FutureProjects;